import React from 'react';
import './style/About.css';
import TopNavbar from './TopNavbar';

const About = () => {
  return (
    <div className="about-container">
      <TopNavbar name="About Us" />

      <div className="about-card">

        {/* Legal Disclaimer Box */}
        <div className="disclaimer-box">
          <div className="disclaimer-header">
            <span className="warning-icon">⚠️</span>
            <h2>LEGAL DISCLAIMER</h2>
          </div>
          <p>
            GATE Exam Prep is an independent educational platform and does not represent a government entity. We are not affiliated with, endorsed by, or connected to the GATE Committee, IISc, any IIT, or any official examination authority.
          </p>
          <div className="official-sources">
            <p><strong>Official Information Sources:</strong></p>
            <ul><br />
              <li><strong>GATE Official Portal:</strong> <a href="https://gate2026.iitm.ac.in" target="_blank" rel="noopener noreferrer">gate2026.iitm.ac.in</a></li>
              <br /> <li><strong>IISc Bangalore:</strong> <a href="https://iisc.ac.in" target="_blank" rel="noopener noreferrer">iisc.ac.in</a></li>
              <br /> <li><strong>Ministry of Education:</strong> <a href="https://www.education.gov.in" target="_blank" rel="noopener noreferrer">education.gov.in</a></li>
            </ul>
          </div>
        </div>

        {/* Main Header */}
        <header className="about-header">
          <h1 className="about-title">About GATE Exam Prep</h1>
          <p className="about-subtitle">
            Your ultimate companion for cracking GATE, pursuing higher studies at IITs/IISc, and securing PSU jobs.
          </p>
        </header>

        {/* Mission Section */}
        <section className="mission-section">
          <h2>Our Mission: Empowering Engineering Graduates</h2>
          <p>
            At GATE Exam Prep, we believe that high-quality guidance for graduate engineering entrance exams should be accessible to every student. We provide structured, branch-wise, and completely free mock tests to help you boost your score.
          </p>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <h2>Comprehensive Preparation for the GATE Examination</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-tag">Branch Wise</span>
              <h3>Core Engineering Mastery</h3>
              <p>Practice for CS, ME, CE, EE, ECE, and other engineering streams tailored to the latest GATE exam pattern.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">PYQ Archive</span>
              <h3>Previous Year Papers</h3>
              <p>Access solved Previous Year Questions with step-by-step solutions for MCQs, MSQs, and NAT questions.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">Full Mock</span>
              <h3>CBT Mode Simulation</h3>
              <p>Experience real Computer Based Test (CBT) interface complete with virtual calculator and timed test series.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">In-Depth Analysis</span>
              <h3>Performance Insights</h3>
              <p>Detailed performance analytics to highlight your strengths and weak areas across core technical subjects, Engineering Math, and Aptitude.</p>
            </div>
          </div>
        </section>

        {/* Highlight Stats Banner */}
        <section className="stats-banner">
          <div className="stat-item">
            <span className="stat-number">10,000+</span>
            <span className="stat-label">MCQs, MSQs & NAT Questions</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">All Major Branches</span>
            <span className="stat-label">CS, ME, CE, EE, ECE & More</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100% Free</span>
            <span className="stat-label">For All Aspirants</span>
          </div>
        </section>
        <br />

        {/* Support Section */}
        <section className="about-contact">
          <p>Have questions or feedback? Contact us at <a href="mailto:contact@mystudyplace.in">contact@mystudyplace.in</a></p>
        </section>
        <br /><br />
      </div>

    </div>
  );
};

export default About;